<template>
  <li class="hs-section" :class="{'hs-section-card': classType === 'card'}">
    <div :class="[!noValue(title) ? 'header' : 'header-short']" :style="{height: !title ? headerShortHeight : ''}">
      <slot name="title">
        <p :type="type">{{title}}</p>
      </slot>
    </div>
    <div class="details" :class="{'hs-section-card-content': classType === 'card' && title}" :style="{backgroundColor: backgroundColor}">
      <slot></slot>
    </div>
  </li>
</template>
<script type="text/ecmascript-6">
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: '#FFFFFF'
    },
    type: {
      type: String,
      default: ''
    },
    classType: {
      type: String,
      default: ''
    },
    headerShortHeight: { // header-Short 高度 与title互斥 title存在时不可用
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-section
  width 100%
  >.header
    @extend .flex-row
    @extend .flex-start
    width 100%
    height 44px
    background-color $color_gray_background_0
    border-top 1px solid $color_gray_layer
    border-bottom 1px solid $color_gray_layer
    padding 0 15px
    font-size 0.8rem
  >.header-short
    @extend .flex-row
    @extend .flex-start
    width 100%
    height 10px
    background-color $color_gray_background_0
    padding 0 10px
  >.header
  >.header-short
    >p[type="mark"]
      border-left 2px solid $color_theme
      padding-left 8px
  >.details
    width 100%
    position relative
  &:last-child
    border-bottom 10px solid rgba(0, 0, 0, 0) !important
.hs-section-card
  width calc(100% - 20px)
  margin-left 10px
  border-radius 10px
  overflow hidden
  margin-bottom 10px
  &:last-child
    border-bottom 0 !important
  >.header
    background-color $color_white
    border none
    font-size 1rem
    padding-left 0
    >p
      border-left 3px solid $color_theme
      padding-left 12px
      font-weight bold
  >.header-short
    display none
  >.details
    width 100%
.hs-section-card-content
  &::before
    display block
    content ' '
    width calc(100% - 30px)
    margin-left 15px
    border-bottom 1px solid $color_gray_layer
</style>
